import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function ContactCenterAssessment() {
  const assessment = getAssessmentById('contact-center')!
  return <AssessmentDetailPage assessment={assessment} />
}
